import { z } from 'zod';
import { BaseFlowBlockSchema } from '../../block.js';
import { FlowBlockType } from '../../type.js';
export const FlowWaitBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.Wait),
    config: z.object({
        waitTimeMillis: z.number(),
    }),
});
//# sourceMappingURL=config.js.map